module.exports = __webpack_public_path__ + "static/img/1234.aa09ebea.jpg";